import { render, staticRenderFns } from "./ManageAssignmentsPage.vue?vue&type=template&id=87bc1774&scoped=true"
import script from "./ManageAssignmentsPage.vue?vue&type=script&lang=ts"
export * from "./ManageAssignmentsPage.vue?vue&type=script&lang=ts"
import style0 from "./ManageAssignmentsPage.vue?vue&type=style&index=0&id=87bc1774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bc1774",
  null
  
)

export default component.exports